require("./m-dossier-tile.scss");

require("./aires-protegees.svg");
require("./autres.svg");
require("./eau.svg");
require("./energie-electrique.svg");
require("./industries.svg");
require("./matieres-residuelles.svg");
require("./mines.svg");
require("./petrole-gaz.svg");
require("./routes.svg");
require("./transport.svg");


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/molecule/m-dossier-tile/m-dossier-tile.chunk.js